import { MOBILE_SCREEN } from 'consts';
import { useLayoutMatchMedia } from 'hooks';

import { Benefits } from './Benefits';
import CostSummaryPanel from './CostSummaryPanel';
import DatesPanel from './DatesPanel';
import { DeliveryType } from './DeliveryType';
import { InformMsgSection } from './InformMsgSection';
import { PermitSection } from './PermitSection';
import { PostcodeSection } from './PostcodeSection';
import { PostcodeSuggestions } from './PostcodeSuggestions';
import QuantityPanel from './QuantityPanel';

import { Row } from 'ui';

import style from './mainBlock.module.scss';

export const MainBlock = ({
  selectingDetails,
  setSelectingDetails,
  setIsPermitModalOpen,
  handleAddProduct,
  isDatesHighlighted,
  setIsDatesHighlighted,
  datesRef,
  mainBtnRef,
  product,
  price,
  postcodeError,
  isBookNowDisabled,
  isPostcodeValidating,
  isTotalPriceLoading,
  postcodeSuggestions,
}) => {
  const isMobile = useLayoutMatchMedia(`(max-width: ${MOBILE_SCREEN}px)`);

  return (
    <div className={style.mainBlock}>
      <Row noWrap>
        <PostcodeSection
          postcode={selectingDetails.postcode}
          setSelectingDetails={setSelectingDetails}
          isMobile={isMobile}
          selectingDetails={selectingDetails}
          postcodeError={postcodeError}
          isPostcodeValidating={isPostcodeValidating}
        />
        {!isMobile && (
          <InformMsgSection
            selectingDetails={selectingDetails}
            postcodeError={postcodeError}
            isPostcodeValidating={isPostcodeValidating}
          />
        )}
      </Row>
      {isMobile && !!postcodeSuggestions.length && (
        <PostcodeSuggestions
          products={postcodeSuggestions}
          currProduct={product}
        />
      )}
      <Row noWrap xsDirection="column">
        <div className={style.rightSide}>
          <DeliveryType
            setSelectingDetails={setSelectingDetails}
            isTotalPriceLoading={isTotalPriceLoading}
          />
          <PermitSection
            setIsPermitModalOpen={setIsPermitModalOpen}
            setSelectingDetails={setSelectingDetails}
            productId={product.id}
            isTotalPriceLoading={isTotalPriceLoading}
          />
        </div>
        {!isMobile && (
          <>
            {postcodeSuggestions.length ? (
              <PostcodeSuggestions
                products={postcodeSuggestions}
                currProduct={product}
              />
            ) : (
              <Benefits />
            )}
          </>
        )}
      </Row>
      <DatesPanel
        selectingDetails={selectingDetails}
        setSelectingDetails={setSelectingDetails}
        isDatesHighlighted={isDatesHighlighted}
        setIsDatesHighlighted={setIsDatesHighlighted}
        datesRef={datesRef}
      />
      <QuantityPanel
        selectingDetails={selectingDetails}
        setSelectingDetails={setSelectingDetails}
        handleAddProduct={handleAddProduct}
        isBookNowDisabled={isBookNowDisabled}
        isTotalPriceLoading={isTotalPriceLoading}
        postcodeError={postcodeError}
        mainBtnRef={mainBtnRef}
      />
      <CostSummaryPanel calculatedPrice={price || 'TBD'} />
    </div>
  );
};
